import { isArrayEmpty, isStrEmpty } from '@/components/common/utils';

export default {
    methods: {
        priceGrand(number) {
            let list_games = !isStrEmpty(localStorage.getItem("list_games"))
                ? JSON.parse(localStorage.getItem("list_games"))
                : this.$store.state.listGameLoto;

            let price = !isArrayEmpty(list_games)
                ? parseFloat(list_games[0]?.estimated_jackpot) * number
                : 0;

            return price;
        },
    },
};
